import { defineRule, configure } from 'vee-validate';
import { all } from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';

async function loadVeeValidateLocale() {
  try {
    // Use raw import to avoid JSON transform issues
    const importLocales = await Promise.all([
      import('@vee-validate/i18n/dist/locale/en.json?raw'),
      import('@vee-validate/i18n/dist/locale/ja.json?raw'),
      import('@vee-validate/i18n/dist/locale/zh_TW.json?raw'),
    ]);
    const localeData = {};
    importLocales.forEach((rawLocale) => {
      const locale = JSON.parse(rawLocale.default)
      localeData[locale.code] = locale;
    });
    configure({
      generateMessage: localize(localeData),
    });
  } catch (error) {
    console.warn('Failed to load vee-validate locales:', error);
  }

  Object.entries(all).forEach(([name, rule]) => {
    defineRule(name, rule);
  });

  // Custom validation rules
  defineRule('halfWidthStrNumSymbols', (value, params, ctx) => {
    const regex = /^[\x21-\x7E]*$/
    if (!regex.test(value)) {
      return $this.$t('common.veeValidate.halfWidthStrNumSymbols', [ctx.field])
    }
    return true
  })
}

loadVeeValidateLocale();
